import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Loader from "../../../common/loader";
import { formateDate, formateDateWithMonth , removeSpecialCharacter } from "../../../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
// import $ from "jquery";
import { RevenueDetails } from "../../../services/reports.sevices";
import Breadcrums from "../../../common/breadcrumbs";
import { Placeholder} from "rsuite";

const RevenueReportView = (props) => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const params = useParams();
  // const [query] = useSearchParams();
  const [showdefault, setShowDefault] = useState({});

  const breadcrumbs = [
    { title: t("sidebar_link_dashboard"), url: "/admin/dashboard" },
    {
      title: t("label_revenue_reports_details"),
      url: "/admin/reports/revenue-reports/list/1",
    },
    { title: t("btn_view"), url: "" },
  ];


  useEffect(() => {
    RevenueDetails(params._id)
      .then((response) => {
        // console.log("View response-", response);
        setShowDefault(response && response.data ? response.data : []);
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params._id]);

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
               <div>
                <h6 className="main-content-label mb-3">{ t("label_appointment_detail")}</h6>
              </div>
              {showdefault && Object.keys(showdefault).length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table
                      id="simple-table"
                      className="table  table-bordered table-hover"
                    >
                      <tbody>

                        <tr>
                          <th>{t("list_heading_name")}</th>
                          <td>
                          {showdefault && showdefault?.name && showdefault?.name ? showdefault?.name : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_user_email")}</th>
                          <td>
                          {showdefault && showdefault.email ?  showdefault.email : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("title_amount")}</th>
                          <td>
                          {showdefault && showdefault?.amount ? showdefault?.amount + '.00' : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("label_type")}</th>
                          <td>
                          {showdefault && showdefault?.transactionType  ? showdefault?.transactionType : "N/A"}
                          </td>
                        </tr>

                        <tr>
                          <th>{t("Role")}</th>
                           <td className="text-capitalize">
                            {showdefault?.role ? (
                                <span
                                className={`badge badge-pill ${
                                  showdefault.role.includes("babe_user")  ? "badge-success-light" : showdefault.role.includes("babe_associate") 
                                        ? "badge-info-light"
                                        : "badge-secondary"
                                }`}
                                >{removeSpecialCharacter(showdefault.role)} </span>
                            ) : ( "N/A" )}
                            </td>
                        </tr>

                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <Placeholder.Paragraph className="w-100 admin-placeholder" rowHeight={30} rowSpacing={5} active={true} rows={7}/>
              )}
            </div>

            <div className="mt-2 back-button mx-4">
              <button
                className="btn ripple btn-dark ripple"
                type="button"
                onClick={() =>
                  navigate("/admin/reports/revenue-reports/list/1")
                }
              >
                <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                {t("btn_back")}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default RevenueReportView;
